import { 
  signIn, 
  signUp, 
  confirmSignUp, 
  signOut, 
  getCurrentUser, 
  fetchAuthSession,
  resetPassword,
  confirmResetPassword,
  resendSignUpCode
} from 'aws-amplify/auth'

const state = {
  user: null,
  isLoggedIn: false,
  session: null,
  tokens: null
}

const mutations = {
  SET_USER(state, user) {
    state.user = user
    state.isLoggedIn = !!user
  },
  SET_SESSION(state, session) {
    state.session = session
    state.tokens = session?.tokens || null

  },
  CLEAR_AUTH(state) {
    state.user = null
    state.isLoggedIn = false
    state.session = null
    state.tokens = null
  }
}

const actions = {
  async signIn({ dispatch }, { username, password }) {
    try {
      const result = await signIn({ username, password })
      
      if (result.isSignedIn) {
        await dispatch('fetchSession')
      }
      
      return result
    } catch (error) {
      console.error('Sign in error:', error)
      throw error
    }
  },

  async signUp(_, { username, password, email }) {
    try {
      const result = await signUp({
        username,
        password,
        attributes: {
          email
        }
      })
      return result
    } catch (error) {
      console.error('Sign up error:', error)
      throw error
    }
  },

  async confirmSignUp(_, { username, code }) {
    try {
      const result = await confirmSignUp({ username, confirmationCode: code })
      return result
    } catch (error) {
      console.error('Confirm sign up error:', error)
      throw error
    }
  },

  async signOut({ commit }) {
    try {
      await signOut()
      commit('CLEAR_AUTH')
    } catch (error) {
      console.error('Sign out error:', error)
      commit('CLEAR_AUTH') // Clear local state even if sign out fails
      throw error
    }
  },

  async fetchSession({ commit }) {
    try {
      const [user, session] = await Promise.all([
        getCurrentUser(),
        fetchAuthSession()
      ])
      
      commit('SET_USER', user)

      commit('SET_SESSION', session)
      
      return { user, session }
    } catch (error) {
      // User not logged in
      commit('CLEAR_AUTH')
      throw error
    }
  },

  async resetPassword(_, { username }) {
    try {
      const result = await resetPassword({ username })
      return result
    } catch (error) {
      console.error('Reset password error:', error)
      throw error
    }
  },

  async confirmResetPassword(_, { username, code, newPassword }) {
    try {
      const result = await confirmResetPassword({
        username,
        confirmationCode: code,
        newPassword
      })
      return result
    } catch (error) {
      console.error('Confirm reset password error:', error)
      throw error
    }
  },

  async resendSignUpCode(_, { username }) {
    try {
      const result = await resendSignUpCode({ username })
      return result
    } catch (error) {
      console.error('Resend sign up code error:', error)
      throw error
    }
  }
}

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  user: state => state.user,
  session: state => state.session,
  tokens: state => state.tokens,
  accessToken: state => state.tokens?.accessToken?.toString(),
  idToken: state => state.tokens?.idToken?.toString(),
  refreshToken: state => state.tokens?.refreshToken?.toString()
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
